<template id="ExtraInfo">
  <section>
    <b-card bg-variant="light">
      <b-form>
        <b-row>
          <b-col>
            <b-form-group
              id="fieldset-ownername"
              label="Owner Name"
              label-for="input-ownername"
            >
              <b-form-input
                id="input-ownername"
                v-model="currentInfo.ownername"
                trim
                :disabled="!edit"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
              id="fieldset-email"
              :description="emailDescription"
              :class="{ 'has-error': emailError }"
            >
            <label :for="currentInfo.email">
              <a v-if="currentInfo.email && !emailError" :href="`mailto:${currentInfo.email}`" target="_blank">{{ "Owner Email" }}</a>
              <a v-else>{{ "Owner Email" }}</a>
            </label>
              <b-form-input
                id="email"
                v-model="currentInfo.email"
                trim
                :disabled="!edit"
                @input="checkEmailValidity"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
              id="fieldset-username"
              description="Username of owner for this repository"
              label="Owner Github Username"
              label-for="input-username"
            >
              <b-form-input
                id="input-username"
                v-model="currentInfo.username"
                trim
                :disabled="!edit"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group
              id="fieldset-fileExchangeID"
              :description="fileExchangeIDDescription"
              :class="{ 'has-error': fileExchangeIDError }"
              >
              <label :for="currentInfo.fileExchangeID">
                <a v-if="!fileExchangeIDError && currentInfo.fileExchangeID" :href="currentInfo.fileExchange" target="_blank">{{ "File Exchange Link" }}</a>
                <a v-else>{{ "File Exchange Link" }}</a>
              </label>

                  <b-form-input
                    id="fileExchangeID"
                    v-model="currentInfo.fileExchangeID"
                    trim
                    :disabled="!edit"
                    @input="checkFileExchangeIDValidity"
                  ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
              id="fieldset-geckoID"
              :description="geckoIDDescription"
              :class="{ 'has-error': geckoIDError }"
            >
                <label :for="currentInfo.geckoID">
                  <a v-if="!geckoIDError && currentInfo.geckoID" :href="currentInfo.gecko" target="_blank">{{ "Gecko Link" }}</a>
                  <a v-else>{{ "Gecko Link" }}</a>
                </label>
                <b-form-input
                  id="geckoID"
                  v-model="currentInfo.geckoID"
                  trim
                  :disabled="!edit"
                  @input="checkGeckoIDValidity"
                ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
              id="fieldset-proposalID"
              :description="proposalIDDescription"
              label="Proposal ID"
              label-for="input-proposalID"
              :class="{ 'has-error': proposalIDError }"

            >
              <b-form-input
                id="input-proposalID"
                v-model="currentInfo.proposalID"
                trim
                :disabled="!edit"
                @input="checkProposalIDValidity"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
              id="fieldset-proposal"
              description="Link to orginal Proposal"
              label-for="input-proposal"
              >
                <label :for="currentInfo.proposal">
                <a v-if="currentInfo.proposal" :href="currentInfo.proposal" target="_blank">{{ "Proposal Link" }}</a>
                <a v-else>{{ "Proposal Link" }}</a>
              </label>
                <b-form-input
                id="input-proposal"
                v-model="currentInfo.proposal"
                trim
                :disabled="!edit"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
            <b-form-group
              id="fieldset-notes"
              description="Space for extra notes"
              label="Notes"
              label-for="input-notes"
            >
              <b-form-input
                id="input-notes"
                v-model="currentInfo.notes"
                trim
                :disabled="!edit"
              ></b-form-input>
            </b-form-group>
  
        <b-row>
          <b-col cols="2">
            <label for="status-dropdown">Status:</label>
            <b-form-select
              id="status-dropdown"
              v-model="currentInfo.status"
              :options="statusOptions"
              :disabled="!edit"
            ></b-form-select>
          </b-col>
        </b-row>

        <div id="formControl">
          <b-button
            v-if="!edit"
            variant="primary"
            @click="editState"
            id="editButton"
          >
            Edit
          </b-button>
          <b-button
            v-else
            variant="outline-secondary"
            @click="cancel"
            id="editButton"
          >
            Cancel
          </b-button>

          <b-button variant="primary" v-if="edit" @click="save">
            Update
          </b-button>
        </div>
      </b-form>
    </b-card>
  </section>
</template>

<script>
export default {
  name: "ExtraInfo",
  props: {
    extraInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    updateInfo: Function,
  },
  data() {
    return {
      edit: false,
      currentInfo: { ...this.extraInfo },
      fileExchangeIDError: false,
      geckoIDError: false,
      proposalIDError: false,
      emailError: false,
      statusOptions: ["Complete", "Follow Up"]
    };
  },
  computed: {
    fileExchangeIDDescription() {
      return this.fileExchangeIDError ? 'Please input only the numerical File Exchange Document ID' : 'File Exchange Document ID';
    },
    geckoIDDescription() {
      return this.geckoIDError ? 'Please input only the numerical Gecko ID' : 'Numerical Gecko ID';
    },

    proposalIDDescription() {
      return this.proposalIDError ? 'Please input only the numerical Proposal ID' : 'Numerical Proposal ID';
    },
    emailDescription() {
      return this.emailError ? 'Please input a valid email' : '';
    },
  },
  methods: {
    cancel() {
      this.currentInfo = { ...this.extraInfo };
      this.edit = false;
    },
    editState() {
      this.edit = true;
    },
    checkFileExchangeIDValidity() {
      if (this.currentInfo &&
        this.currentInfo.fileExchangeID) { 

          if (!/^\d*$/.test(this.currentInfo.fileExchangeID)) { // seperate boolean conditions so blank form isn't an error
            this.fileExchangeIDError = true;
            return;
          }
        }
        this.fileExchangeIDError = false;
    },
    
    checkGeckoIDValidity() {
      if (this.currentInfo &&
      this.currentInfo.geckoID) {
        
        if (!/^\d*$/.test(this.currentInfo.geckoID)) { // seperate boolean conditions so blank form isn't an error
          this.geckoIDError = true;
          return;
        }
      }
      this.geckoIDError = false;
    },
    
    checkProposalIDValidity() {
      if (this.currentInfo &&
      this.currentInfo.proposalID) {
        
        if (!/^\d*$/.test(this.currentInfo.proposalID)) { // seperate boolean conditions so blank form isn't an error
          this.proposalIDError = true;
          return;
        }
      }
      this.proposalIDError = false;
    },
    
    checkEmailValidity() {
      if (this.currentInfo &&
      this.currentInfo.email) {
        
        if (!/^[\w\-\.]+@([\w-]+\.)+[\w-]{2,}$/.test(this.currentInfo.email)) { // seperate boolean conditions so blank form isn't an error
          this.emailError = true;
          return;
        }
      }
      this.emailError = false;
    },

    save() {
      // extra check needed for a put-then-get edge case- 
      // good match is empty, digits, or a url. 
      this.checkFileExchangeIDValidity();
      this.checkGeckoIDValidity();
      this.checkProposalIDValidity();
      this.checkEmailValidity();


      if (!this.fileExchangeIDError && 
          !this.geckoIDError        &&
          !this.proposalIDError        &&
          !this.emailError) {

        // if fileExchange/gecko is just an id, converts into full url. 
        // only performs conversion if no errors bc it looks smoother
        // that way. 
        if (
          this.currentInfo &&
          this.currentInfo.fileExchangeID &&
          /^\d*$/.test(this.currentInfo.fileExchangeID)
          ) {
            this.currentInfo.fileExchange =
            process.env.VUE_APP_FILEEXCHANGE_FORMAT +
            this.currentInfo.fileExchangeID;
            this.fileExchangeIDError = false;
          }
        if (
          this.currentInfo &&
          this.currentInfo.geckoID &&
          /^\d*$/.test(this.currentInfo.geckoID)
        ) {
          this.currentInfo.gecko =
          process.env.VUE_APP_GECKO_FORMAT +
          this.currentInfo.geckoID;
          this.geckoIDError = false;
        }
            // final success
            this.updateInfo(this.currentInfo);
            this.edit = false;

          }
    },
  },
};
</script>

<style scoped>
#editButton {
  margin-right: 10px;
}
#formControl {
  margin: 10px 0 10px 0;
}
.has-error .form-control,
.has-error .form-control:focus {
  border-color: red;
}

/* .dropdown-container {
  margin-left: 12px
} */


</style>
